// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: 7jCYJVNv9q

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
} from "@plasmicapp/react-web";
import PermissionRule from "../../components/app-auth/PermissionRule"; // plasmic-import: OKf_hhc2Skl/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_plasmic_kit_color_tokens_css from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss
import plasmic_plasmic_kit_style_controls_css from "../plasmic_kit_style_controls/plasmic_plasmic_kit_styles_pane.module.css"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectcss
import plasmic_plasmic_kit_design_system_css from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import projectcss from "./plasmic_plasmic_kit_end_user_management.module.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicPermissionRuleGroup.module.css"; // plasmic-import: 7jCYJVNv9q/css

createPlasmicElementProxy;

export type PlasmicPermissionRuleGroup__VariantMembers = {};
export type PlasmicPermissionRuleGroup__VariantsArgs = {};
type VariantPropType = keyof PlasmicPermissionRuleGroup__VariantsArgs;
export const PlasmicPermissionRuleGroup__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPermissionRuleGroup__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPermissionRuleGroup__ArgsType;
export const PlasmicPermissionRuleGroup__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicPermissionRuleGroup__OverridesType = {
  root?: p.Flex<"div">;
};

export interface DefaultPermissionRuleGroupProps {
  children?: React.ReactNode;
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicPermissionRuleGroup__RenderFunc(props: {
  variants: PlasmicPermissionRuleGroup__VariantsArgs;
  args: PlasmicPermissionRuleGroup__ArgsType;
  overrides: PlasmicPermissionRuleGroup__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    true ? (
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_plasmic_kit_color_tokens_css.plasmic_tokens,
          plasmic_plasmic_kit_design_system_css.plasmic_tokens,
          plasmic_plasmic_kit_style_controls_css.plasmic_tokens,
          sty.root
        )}
      >
        {p.renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <PermissionRule
                className={classNames(
                  "__wab_instance",
                  sty.permissionRule__rr4E
                )}
                ruleName={"Anonymous visitors"}
              />

              <PermissionRule
                className={classNames(
                  "__wab_instance",
                  sty.permissionRule__lhnJ2
                )}
                isGroup={true}
                ruleName={"Logged in users"}
              />

              <PermissionRule
                className={classNames(
                  "__wab_instance",
                  sty.permissionRule__nvdAj
                )}
                hasMenu={true}
                isGroup={true}
                ruleName={"Logged in users"}
                withoutBorder={true}
              />
            </React.Fragment>
          ),

          value: args.children,
        })}
      </div>
    ) : null
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPermissionRuleGroup__OverridesType,
  DescendantsType<T>
>;

type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPermissionRuleGroup__VariantsArgs;
    args?: PlasmicPermissionRuleGroup__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPermissionRuleGroup__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicPermissionRuleGroup__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicPermissionRuleGroup__ArgProps,
          internalVariantPropNames: PlasmicPermissionRuleGroup__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPermissionRuleGroup__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPermissionRuleGroup";
  } else {
    func.displayName = `PlasmicPermissionRuleGroup.${nodeName}`;
  }
  return func;
}

export const PlasmicPermissionRuleGroup = Object.assign(
  // Top-level PlasmicPermissionRuleGroup renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicPermissionRuleGroup
    internalVariantProps: PlasmicPermissionRuleGroup__VariantProps,
    internalArgProps: PlasmicPermissionRuleGroup__ArgProps,
  }
);

export default PlasmicPermissionRuleGroup;
/* prettier-ignore-end */
